/**
 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
 * http://www.mathgraph32.org/
 * @Author Yves Biton (yves.biton@sesamath.net)
 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
 */
module.exports = Color
/**
 * Classe couleur
 * @constructor
 * @param {Integer} red Composante rouge
 * @param {Integer} green Composante verte
 * @param {Integer} blue Composante bleue
 * @returns {undefined}
 */
function Color (red, green, blue) {
  this.red = red
  this.green = green
  this.blue = blue
}
/**
 * Renvoie la couleur rouge
 * @returns {Integer}
 */
Color.prototype.getRed = function() {
  return this.red
}
/**
 * Renvoie la couleur verte
 * @returns {Integer}
 */
Color.prototype.getGreen = function() {
  return this.green
}
/**
 *
 * @returns {Integer}Renvoie la couleur bleue
 */
Color.prototype.getBlue = function() {
  return this.blue
}
/**
 * Fonction renvoyant le code couleur pour du LaTeX
 * @returns {String}
 */
Color.prototype.rgb = function() {
  return "rgb("+this.red+","+this.green+","+this.blue+")"
}
/**
 * Fonctio renvoyant true si la couleur est blanche
 * @returns {Boolean}
 */
Color.prototype.isWhite = function() {
  return (this.red === 255) && (this.green === 255) && (this.blue === 255)
}
Color.black = new Color(0,0,0)
Color.blue = new Color(0,0,255)
Color.red = new Color(255,0,0)
Color.green = new Color(0,255,0)
Color.white = new Color(255,255,255)
Color.yellow = new Color(255,255,0)
Color.gray = new Color(128,128,128)
